export default function () {
  function doStoreInCache(key: string, obj: any, config: any) {
    const ttl = config['ttl'] || 1000 * 60 * 3; // Default 3 mins expiry
    const now = new Date();
    const storedItem = {
      item: obj,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(storedItem));
  }

  function storeInCache(key: string, obj: any, config: any) {
    doStoreInCache(key, obj, config);
  }

  function storeRedirUrlInCache(action: string, extras: any = {}) {
    storeInCache(
      'redirect_from_login',
      { url: window.location.href, action: action, ...extras },
      { ttl: 1000 * 60 * 30 } // 30 mins
    );
  }

  function deleteFromCache(key: string) {
    localStorage.removeItem(key);
  }

  function deleteRedirFromCache() {
    deleteFromCache('redirect_from_login');
  }

  function getFromCache(key: string) {
    // Check expiry
    const fromCache = localStorage.getItem(key);
    if (fromCache == null) return null;

    const parsed = JSON.parse(fromCache);
    const expiryDate = parsed.expiry;
    const curDate = new Date();
    if (curDate.getTime() < expiryDate) {
      return parsed.item;
    }
    return null;
  }

  function getRedirUrlFromCache() {
    return getFromCache('redirect_from_login');
  }

  function useCache(
    // Key used to store in localStorage
    key: string,
    // Any promise
    promise: Promise<any>,
    // Configuration hash
    config: any = {}
  ): Promise<any> {
    return new Promise((res, rej) => {
      console.log('useLocalCache', key);
      const fromCache = localStorage.getItem(key);

      if (!fromCache) {
        console.log('useLocalCache', key, "cache doesn't exist");
        promise
          .then(result => {
            doStoreInCache(key, result, config);
            res(result);
          })
          .catch(err => {
            rej(err);
          });
      } else {
        // Check expiry
        const parsed = JSON.parse(fromCache);
        const expiryDate = parsed.expiry;
        const curDate = new Date();
        if (curDate.getTime() > expiryDate) {
          console.log('useLocalCache', key, 'cache exists but expired');
          // Expired? redo promise and refresh cache
          promise
            .then(result => {
              doStoreInCache(key, result, config);
              res(result);
            })
            .catch(err => {
              rej(err);
            });
        } else {
          console.log('useLocalCache', key, 'cache exists and is still valid');
          res(parsed.item);
        }
      }
    });
  }

  return {
    useCache,
    storeInCache,
    storeRedirUrlInCache,
    getRedirUrlFromCache,
    getFromCache,
    deleteFromCache,
    deleteRedirFromCache,
  };
}
